import {Component, ElementRef, ViewChild} from '@angular/core';
import {MenuPartial} from '../menu/menu-partial';
import {LayoutService} from '../../../services/layout.service';
import {Drawer} from 'primeng/drawer';
import {LogoPartial} from '../logo/logo-partial';
import {RouterLink} from '@angular/router';
import {ROLES} from '../../../datas/roles.helpers';
import {environment} from '../../../../../environments/environment';
import {
  BtnBugReportPartialDirective
} from '../../../../modules/eDevelopment/directives/partial/btnBugReport/btnBugReport.partial.directive';
import {PeopleWithrightsInterface} from '../../../interfaces/peopleWithrights.interface';
import {AppSessionService} from '../../../services/app.session.service';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar-partial.html',
  imports: [MenuPartial, LogoPartial, RouterLink, BtnBugReportPartialDirective, NgClass]
})
export class SidebarPartial {


  @ViewChild('drawerRef') drawerRef!: Drawer;

  public user: PeopleWithrightsInterface;

  closeCallback(e: any): void {
    this.drawerRef.close(e);
  }
  visible: boolean = false;

  constructor(
    public el: ElementRef,
    public layoutService: LayoutService,
    public _sessionService: AppSessionService,
  ) {

    this._sessionService.logguedAccountEmitter.subscribe((people) => {
      this.user = people;
    })

  }

  protected readonly ROLES = ROLES;
  protected readonly environment = environment;
}
